import {
  ListGroup, 
  ListGroupItem, 
  ListGroupItemHeading, 
} from 'reactstrap';

function TrainingNavigation(props) {
  const { steps, currentStep, handleItemClick, showLabel } = props;
  console.log("rendering TrainingNavigation, with props: ", props);
  return (
    <>
      <ListGroup className='instruct-navigation-listgroup' flush={true}>
        {steps && steps.map((item) => {
          if (item.StepType !== 4) {
            const isActive = steps[currentStep] && (item.Index === currentStep || (steps[currentStep].StepType === 4 && item.Index + 1 === currentStep));
            const stepLabel = item.StepType === 3 && (item.Title !== 'Preview Checklist' && item.Title !== 'Review Checklist') ? `Step ${item.Step}` : '' ;
            return (
              <ListGroupItem
                className={isActive ? "instruct-selected-navigation-item" : "instruct-navigation-item"}
                key={item.Index}
                onClick={() => handleItemClick(item)}
              >
                <div>
                  {stepLabel ?
                    <ListGroupItemHeading>{stepLabel}<br />{item.Title}</ListGroupItemHeading>
                  :
                    <ListGroupItemHeading>{item.Title}</ListGroupItemHeading>
                  }
                </div>
              </ListGroupItem>
            );
          } else {
            return null;
          }
        })}
      </ListGroup>
    </>
  );
}
export default TrainingNavigation;